import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateNewPass from "../CreateNewPass";
import { NavLink } from "react-router-dom";

const PasswordReset = () => {

    const history = useNavigate();


    return (
        <>
            <div className="bg-grey-100 centerr ">
                <div className="Emailform">
                    <div className='verify-bg'>
                        <div className='container'>
                            <h1 className='text-white  verif-text'>Reset your password</h1>
                        </div>

                    </div>
                    <div className='container verif p-5'>
                        <p className='fs18'>You’re recieving this email because you requested a password reset for your Next Capital account. Please tap the button below to choose a new password.
                        </p>
                    <NavLink to='/CreateNewPass'>    <button className='btn-filled p-2 px-3 font-bold'>Reset Password</button></NavLink>
                        <div className='mt-5'>
                            <hr />
                        </div>

                        <div className='mt-3'>
                            <span className='t-grey-600'>  © Next Capital Limited. 2021</span>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default PasswordReset;